import lozad from 'lozad';
import showcase from './showcase';

const lazy = () => {
  const observer = lozad('.u-lazy', {
    rootMargin: '10px 0px',
    threshold: 0.1,
    loaded() {
      showcase.grid();
    },
  });
  observer.observe();

  // eslint-disable-next-line no-undef
  jQuery(document).on('facetwp-loaded', () => observer.observe());

  window.addEventListener('DOMContentLoaded', () => observer.observe());
};

export default lazy;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/lazy.js